module.exports = __webpack_public_path__ + "static/media/settings-divider.031c5056.png";